<template>
  <v-card class="hvh-card--rounded hvh-analysis-visualization">
    <v-card-title class="pb-3 pl-4">
      <div class="hvh-analysis-visualization__title">
        <slot name="title" />
      </div>
      <div class="hvh-analysis-visualization__metadata">
        <slot name="metadata" />
      </div>
      <v-spacer />
      <div class="hvh-analysis-visualization__actions">
        <slot name="actions" />
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text class="px-0">
      <div class="hvh-analysis-visualization__summary">
        <slot name="summary" />
      </div>
      <div class="hvh-analysis-visualization__help">
        <slot name="help" />
      </div>
      <div class="hvh-analysis-visualization__chart" :style="boxStyle">
        <slot name="visualization">
          <v-progress-circular indeterminate color="primary" size="65" class="hvh-progress-indicator" />
        </slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { propToBool } from '../../libraries/common'
export default {
  props: ['noMinHeight'],
  computed: {
    boxStyle() {
      return propToBool(this.noMinHeight) ? {} : { 'min-height': '150px' };
    },
  },
}
</script>

<style lang="scss">
.hvh-analysis-visualization__metadata {
  border-left: 1px solid $color-border-default;
  margin-left: rem(20px);
  padding-left: rem(20px);
}

.hvh-analysis-visualization__help {
  position: relative;
  text-align: right;
  z-index: 1;
}

.hvh-analysis-visualization__chart {
  position: relative;

  .hvh-progress-indicator {
    position: absolute;
    margin: rem(-32.5px) auto 0;
    top: 50%;
    left: 0;
    right: 0;
  }
}
</style>
